export default __webpack_public_path__ + "57eb640b46f9cb667d643131c64f27a0.webp";